import Message from "../../message";
import {useMainStore} from "@/store";

export default class GuildRenamed extends Message
{
    handle()
    {
        useMainStore().RENAME_GUILD(this.message.name);
    }
}
